<template>
	<div class="officebodyContent">
		<FloatingContactControls />
		<div class="mainContent">
			<mainpage></mainpage>
		</div>
		<div class="footer">
			<footerBlock class="homeFooterBlock"></footerBlock>
		</div>
	</div>
</template>

<script>
import footerBlock from './footerBlock'
import mainpage from './mainpage'
import FloatingContactControls from './FloatingContactControls.vue'
export default {
	components:{footerBlock,mainpage}//如果需要侧边联系我们按钮请加入：FloatingContactControls
}
</script>

<style lang="scss" scoped>
.officebodyContent{
	width: 100%;
	height: 100%;
	overflow: auto;
	.mainContent{
		min-height: 1000px;
		width: 100%;
	}
	.footer{
		height: 406px;
		width: 100%;
		.homeFooterBlock{
			box-sizing: border-box;
			height: 406px;
			background: #0D1E33;
		}
	}
}
</style>
